module.exports = __webpack_public_path__ + "img/已完成提前.00e45815.svg";